import type { DataItem as JobHistoryTableDataItem } from '@/components/tables/JobHistoryTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { formatInTimeZone } from 'date-fns-tz';
// import { format, toZonedTime } from 'date-fns-tz';

import { getStrCell } from '@/utils/file';
import * as commonConstants from '@/constants/common';

const timeZone = 'Australia/Sydney';

function getTime(date: string | undefined, timeZone: string): string {
  if (!date) return commonConstants.EM_DASH;
  try {
    // return format(toZonedTime(date, timeZone), 'yyyy-MM-dd HH:mm:ss'); // it gives the same result
    return formatInTimeZone(date, timeZone, 'yyyy-MM-dd HH:mm:ss');
  } catch (err) {
    return commonConstants.EM_DASH;
  }
}

export function getTableItem(
  jobHistoryLog: openapi.JobLogOpenapi,
  jobHistoryLogIndex: number,
): JobHistoryTableDataItem {
  return {
    id: jobHistoryLogIndex,
    source: getStrCell(jobHistoryLog.source),
    time: getTime(jobHistoryLog.action_time, timeZone),
    timeTooltip: jobHistoryLog.action_time || '',
    message: getStrCell(jobHistoryLog.change_message),
    user: getStrCell(jobHistoryLog.user),
  };
}
